import { render, staticRenderFns } from "./NewsletterDescription.vue?vue&type=template&id=d6ec80ec&scoped=true&"
import script from "./NewsletterDescription.vue?vue&type=script&lang=js&"
export * from "./NewsletterDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ec80ec",
  null
  
)

export default component.exports